module.exports = __webpack_public_path__ + "img/eyeclose.674882b7.svg";